import { Card, Chip, Grid, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { BuySellTxType } from 'src/type/trade-tx';
import { TransactionStatus } from 'src/type/transaction';
import { fNumber } from 'src/utils/format-number';
import { fDateTime } from 'src/utils/format-time';
import { txStatusLabel } from '../__gold-withdraw/utils';
import { txAction } from './utils';

type Props = {
  tradeTx: BuySellTxType;
};

export default function TradeTxCard({ tradeTx }: Props) {
  const { user, product, paidAt, fee, unitName, currency, total, amount, status, type } = tradeTx;

  return (
    <Card sx={{ boxShadow: 0, p: 2, bgcolor: (theme) => alpha(theme.palette.grey[500], 0.16) }}>
      <Grid container>
        <Grid item xs={12} md={4}>
          <Stack justifyContent="center">
            <Typography variant="subtitle2">
              {txAction(type)} {product.name} โดย {user?.firstName}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {paidAt ? fDateTime(paidAt) : ''}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {total ? `ราคา : ${fNumber(total)} ${currency}` : ''}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {fee ? `ค่าธรรมเนียม : ${fNumber(fee)} ${currency}` : ''}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} md={4} display="flex" alignItems="center" justifyContent="center">
          <Typography variant="subtitle1" textAlign="center">
            {fNumber(amount)} {unitName}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4} display="flex" alignItems="center" justifyContent="flex-end">
          <Chip
            label={txStatusLabel(status)}
            color={
              (status === TransactionStatus.SUCCESS && 'success') ||
              (status === TransactionStatus.PENDING && 'warning') ||
              (status === TransactionStatus.REJECTED && 'error') ||
              (status === TransactionStatus.CANCEL && 'info') ||
              'default'
            }
          />
        </Grid>
      </Grid>
    </Card>
  );
}
